import styled from "styled-components";

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;

  border-color: ${({ theme }) => theme.border};
  border-bottom-width: 0.5px;
  border-bottom-style: solid;

  margin-bottom: 15px;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  justify-content: space-between;

  width: 40%;

  @media (max-width: 768px) {
    width: 95%;
  }

  max-width: 650px;

`;

export const InfoButton = styled.button`
  width: 36px;
  height: 36px;
  padding: 0;
  color: ${({ theme }) => theme.text};
  background: transparent;
  border: 0;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    opacity: 0.8;
  }
`;

export const Logo = styled.h1`
  color: ${({ theme }) => theme.text};
  font-family: "Roboto Serif", serif;
  text-transform: uppercase;
  width: max-content;
  font-size: 1.8rem;

  -webkit-touch-callout: none;
  user-select: none;
`;
